import { useState } from 'react';

import { ConversionParamsContext } from '@/contexts';

const ConversionParamsProvider = ({ children, source = '', target = '' }) => {
  const [sourceParam] = useState(source);
  const [targetParam] = useState(target);

  return (
    <ConversionParamsContext.Provider value={{ sourceParam, targetParam }}>
      {children}
    </ConversionParamsContext.Provider>
  );
};

export default ConversionParamsProvider;
